(function() {
    'use strict';
     
a3_pilot_reports.factory("LogService",LogService);

/**
    * @memberof PilotReports
    * @ngdoc factory
    * @name LogService
    * @description 
    *  The error log service is our wrapper around the core error
    *  handling ability of AngularJS. Notice that we pass off to
    *  the native "$log" method and then handle our additional
    *  server-side logging.
    * @ngInject
    */
function LogService( $log,$injector ,$window, apiUrl, UserTokenFactory ,version) {
	var lastError=null;
    var acceptedTimeDiff = 5; 
    
    function post(errorMessage,stackTrace,cause){
			
			try {
				var $http = $injector.get("$http");
		    	/*// get the user token
		    	var user = UserFactory.getUser();
		    	var token = '';
		    	if (user != null)
		    		token = user.token;*/
				var token = UserTokenFactory.getToken();
				// Log the JavaScript error to the server.
				// --
				// NOTE: In this demo, the POST URL doesn't
				// exists and will simply return a 404.
				$http({
					method: "POST",
					url: apiUrl +"/log",
					contentType: "application/json",
					data:{
						errorUrl: $window.location.href,
						errorMessage: version + " " +errorMessage ,
						stackTrace: stackTrace,
						cause: ( cause || "" )
					},
					beforeSend: function (request)
		            {
		                request.setRequestHeader('X-CrewToken', token);
		            }
				});
				

			} catch ( loggingError ) {

				// For Developers - log the log-failure.
				$log.warn( "Error logging failed" );
				$log.log( loggingError );

			}
		};

    function postFilter(errorMessage,stackTrace,cause){
				if(lastError!=null && lastError.errorDescr==errorMessage){
				var timestampDiff=Date.now()-lastError.timestamp;
				var timeDiffInSec = timestampDiff / 1000;
					if (timeDiffInSec > acceptedTimeDiff){
                        lastError={'errorDescr': errorMessage,
						'timestamp': Date.now()};
					post(errorMessage,stackTrace,cause);
					}
				}else{
                    lastError={'errorDescr': errorMessage,
						'timestamp': Date.now()};
					post(errorMessage,stackTrace,cause);
				}
		};
		
	return {
	debug : function ( errorMessage, error ){
			if (error==null){
				error=new Error();
			}
			if(errorMessage!=null){
				error.description=errorMessage;
			}

			post(error.description,error.stack,"");
		
	},
	error : function(exception,cause) {

			// Pass off the error to the default error handler
			// on the AngualrJS logger. This will output the
			// error to the console (and let the application
			// keep running normally for the user).
			$log.error.apply( $log, arguments );

			// Now, we need to try and log the error the server.
			// --
			// NOTE: In production, I have some debouncing
			// logic here to prevent the same client from
			// logging the same error over and over again! All
			// that would do is add noise to the log.
			var errorMessage = exception.toString();
			//var stackTrace = stacktraceService.print({ e: exception });
			//var stackTrace = $log.info({ e: exception });
			var stackTrace = exception.stack;

			postFilter(errorMessage,stackTrace,cause);

			}
		};
		
}

})();